import { GetLodgingsState, GetLodgingsActionTypes, GET_LODGINGS_DATA_REQUEST, GET_LODGINGS_DATA_SUCCESS, GET_LODGINGS_DATA_FAILURE } from "store/reducers/lodgingOption/get/types";

const defaultState: GetLodgingsState = {
  isLoading: false,
  errorMessage: ""
};

export default function getLodgings(state = defaultState, action: GetLodgingsActionTypes): GetLodgingsState {
  switch (action.type) {
    case GET_LODGINGS_DATA_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case GET_LODGINGS_DATA_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case GET_LODGINGS_DATA_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};